import React from 'react';

import styled from 'styled-components';
import { style } from '../../style';

import { ReactComponent as IconAddText } from './icons/add_text.svg';
import { ReactComponent as IconAddVideo } from './icons/add_video.svg';
import { ReactComponent as IconAddImages } from './icons/add_images.svg';
import { ReactComponent as IconAddLink } from './icons/add_link.svg';

const ContainerAddPostContent = styled.div`
    /* width: 100%; */
    padding: 2rem;
    height: 70px;
    margin: 0 auto;

    display:flex;
    align-items: center;
    gap: 2rem;
    
    position: sticky;
    top: -1%;
    left: 0;
    z-index: 10;

    background-color: white;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
`;

const ItemAddPostContent = styled.div`
    height: 100%;
    border-radius: 5px;
    padding: 2rem 1.5rem;

    background-color: #F4F6FB;
    color: #7D86A1;

    display: flex;
    align-items: center;
    justify-content: center;
    gap:0.5rem;

    cursor:pointer;

    span{
        font-size:16px;
    }

    &:hover{
        background-color:${style.inpuStyle.colorInput};
        color:white;
        svg {
            path {
              fill: ${({ isIconText }) => isIconText ? 'white' : style.inpuStyle.colorInput};
              stroke: ${({ isIconText }) => !isIconText && 'white'};
            }
          }
    }
`

export function AddPostContent(props) {

    return (
        <ContainerAddPostContent>
            <ItemAddPostContent isIconText={true} onClick={props.InsertComponentText}>
                <IconAddText/>
                <span>texto</span>
            </ItemAddPostContent>

            <ItemAddPostContent onClick={()=>props.showDialogUploadFile('video')}>
                <IconAddVideo/>
                <span>vídeo</span>
            </ItemAddPostContent>

            <ItemAddPostContent onClick={()=>props.showDialogUploadFile('image')}>
                <IconAddImages/>
                <span>imagens</span>
            </ItemAddPostContent>

            <ItemAddPostContent onClick={()=>props.showDialogUploadFile('link')}>
                <IconAddLink/>
                <span>link</span>
            </ItemAddPostContent>
            
        </ContainerAddPostContent>
    )
}